export default __webpack_public_path__ + "static/animated-logo-01475e94e582f6b9cda6d4a1c4d907a4.svg";